export const turnoverOptions = [
  { label: $localize`:@@option-values.dashboardOptionsFlight:Flight`, value: 'AIR' },
  { label: $localize`:@@option-values.dashboardOptionsHotel:Hotel`, value: 'HOTEL' },
  { label: $localize`:@@option-values.TOMA:TOMA`, value: 'TOMA' },
  { label: $localize`:@@option-values.carSegment:Car`, value: 'CAR' }
];

export const dateTypeOptions = [
  { label: $localize`:@@option-values.dashboardOptionsTravelSeasonality:Travel seasonality`, value: 'segment_date' },
  { label: $localize`:@@option-values.dashboardDateTypePickupDate:Pickup date`, value: 'pickup_date' },
  { label: $localize`:@@option-values.dashboardOptionsTicketIssuance:Ticket Issuance`, value: 'date' },
  { label: $localize`:@@option-values.dashboardOptionsPnrCreation:PNR creation`, value: 'creation_date' }
];
export const allowedDateTypes = {
  AIR: ['segment_date', 'date', 'creation_date'],
  CAR: ['segment_date', 'creation_date'],
  HOTEL: ['segment_date', 'creation_date'],
  TOMA: ['segment_date', 'creation_date']
};

export const valueOptions = [
  { label: $localize`:@@option-values.dashboardOptionsValue:Value`, value: 'value' },
  { label: $localize`:@@option-values.dashboardOptionsPnrs:PNRs`, value: 'PNR' },
  { label: $localize`:@@option-values.dashboardOptionsPassengers:Passengers`, value: 'passengers' },
  { label: $localize`:@@option-values.dashboardOptionsSegments:Segments`, value: 'segment' }
];

export const groupingOptions = [
  { label: $localize`:@@option-values.dashboardOptionsProviders:Providers`, value: 'default' },
  { label: $localize`:@@option-values.dashboardOptionsConsultants:Consultants`, value: 'consultants' }
];
